import type { SelectOptionType } from '../../type';

import { useMemo } from 'react';

interface UseSearchProps {
  options?: SelectOptionType[];
  queryValue: string;
  enableCreateOption?: boolean;
}

export const useSearch = ({ options, queryValue, enableCreateOption }: UseSearchProps) => {
  const filteredOptions = useMemo(() => {
    if (!options?.length || !queryValue) return options ?? [];

    return options.filter((opt) => opt.label.toLowerCase().includes(queryValue.toLowerCase()));
  }, [options, queryValue]);

  const finalOptions = useMemo(() => {
    if (filteredOptions.length > 0) return filteredOptions;

    if (!enableCreateOption || !queryValue) return filteredOptions;

    return [
      ...filteredOptions,
      {
        label: queryValue,
        value: queryValue,
      },
    ];
  }, [filteredOptions, enableCreateOption, queryValue]);

  return {
    options: finalOptions,
  };
};
